/**
 * UI Registry Mod 定义
 *
 * ui-registry-mod 的运行时定义，组合五个 Registry 服务：
 * - IPageRouteRegistryService: 页面路由注册
 * - IGlobalStateRegistryService: 全局状态注册
 * - IComponentRegistryService: 组件注册
 * - IHooksRegistryService: Hooks 注册
 * - IClientServiceRegistryService: 业务服务注册
 *
 * 纯数据管理层，零 UI 依赖，可独立发布。
 */
import { PAGE_ROUTE_REGISTRY_INTERFACE_TAG, GLOBAL_STATE_REGISTRY_INTERFACE_TAG, COMPONENT_REGISTRY_INTERFACE_TAG, HOOKS_REGISTRY_INTERFACE_TAG, CLIENT_SERVICE_REGISTRY_INTERFACE_TAG, } from '@hvsin/ui-registry-contracts';
import { PageRouteRegistryService } from './page-route-registry.js';
import { GlobalStateRegistryService } from './global-state-registry.js';
import { ComponentRegistryService } from './component-registry.js';
import { HooksRegistryService } from './hooks-registry.js';
import { ClientServiceRegistryService } from './client-service-registry.js';
/**
 * ui-registry-mod 定义
 *
 * 提供五个 Registry 服务，业务 Mod 通过 DI 引用获取实例完成注册。
 *
 * 使用方式：
 * ```typescript
 * import { uiRegistryMod } from '@hvsin/mod-ui-registry'
 *
 * await container.loadMods([uiRegistryMod, ...businessMods])
 * ```
 */
export const uiRegistryMod = {
    name: 'ui-registry',
    serviceDefs: [
        {
            serviceTag: 'pageRouteRegistry',
            serviceImpl: PageRouteRegistryService,
            serviceInterfaceTag: PAGE_ROUTE_REGISTRY_INTERFACE_TAG,
            dependencies: ['IEventBusService'],
        },
        {
            serviceTag: 'globalStateRegistry',
            serviceImpl: GlobalStateRegistryService,
            serviceInterfaceTag: GLOBAL_STATE_REGISTRY_INTERFACE_TAG,
            dependencies: ['IEventBusService'],
        },
        {
            serviceTag: 'componentRegistry',
            serviceImpl: ComponentRegistryService,
            serviceInterfaceTag: COMPONENT_REGISTRY_INTERFACE_TAG,
            dependencies: ['IEventBusService'],
        },
        {
            serviceTag: 'hooksRegistry',
            serviceImpl: HooksRegistryService,
            serviceInterfaceTag: HOOKS_REGISTRY_INTERFACE_TAG,
            dependencies: ['IEventBusService'],
        },
        {
            serviceTag: 'clientServiceRegistry',
            serviceImpl: ClientServiceRegistryService,
            serviceInterfaceTag: CLIENT_SERVICE_REGISTRY_INTERFACE_TAG,
            dependencies: ['IEventBusService'],
        },
    ],
};
//# sourceMappingURL=mod.js.map